import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sortCategoryIndex: 0,
  sortOrderIndex: 0,
  searchType: 'searchOptions',
  searchOptions: {
    packingStyle: 'single',
    itemCategory: 'all',
    itemSubCategory: {
      okazu: false,
      gohantsuki: false,
      alacarte: false,
      sweets: false,
    },
    seasonTag: {
      new: false,
      season: false,
    },
    cookingStyle: {
      japanese: false,
      western: false,
      chinese: false,
      korean: false,
    },
    otherOption: {
      recommend: false,
      favorite: false
    },
    setCategory: 'other',
    energy: {
      lower: null,
      upper: null
    },
    salt: {
      lower: null,
      upper: null
    },
    allergens: {
      shrimp: true,
      crab: true,
      malt: true,
      soba: true,
      milk: true,
      egg: true,
      peanut: true,
    },
  },
  searchPreset: null,
  bloodTest: {
    gender: 2,
    base: {
      height: null,
      weight: null,
      age: null,
    },
    result: {
      bp_h: null,
      bp_l: null,
      glu: null,
      hdl: null,
      ldl: null,
      tg: null,
      hba1c: null,
      cre: null,
      ua: null,
    }
  },
  searchCatalogCodes: {
    0: {
      name: null,
      code: null,
      item_code: null,
      num: 1,
      price: null,
      discountPrice: null,
      result: null
    }
  }
}

export const itemSearchOptionSlice = createSlice({
  name: 'itemSearchOption',
  initialState,
  reducers: {
    hydrateSearchOption: (state, action) => {
      return {
        ...state,
        sortCategoryIndex: action.payload.sortCategoryIndex,
        sortOrderIndex: action.payload.sortOrderIndex,
      }
    },
    setCategoryCode: (state, action) => {
      return {
        ...state,
        sortCategoryIndex: action.payload,
      }
    },
    setSortOrder: (state, action) => {
      return {
        ...state,
        sortOrderIndex: action.payload,
      }
    },
    setSearchType: (state, action) => {
      return {
        ...state,
        searchType: action.payload,
      }
    },
    setSearchOptions: (state, action) => {
      return {
        ...state,
        searchOptions: action.payload,
      }
    },
    resetSearchOptions: (state) => {
      return {
        ...state,
        searchOptions: initialState.searchOptions,
      }
    },
    setSearchPreset: (state, action) => {
      return {
        ...state,
        searchPreset: action.payload
      }
    },
    setBloodTest: (state, action) => {
      return {
        ...state,
        bloodTest: action.payload
      }
    },
    resetBloodTest: (state) => {
      return {
        ...state,
        bloodTest: initialState.bloodTest,
      }
    },
    addCatalogCodes: (state, action) => {
      let code = {}
      const key = isFinite(action.payload) ? action.payload + 1 : 0
      code[key] = initialState.searchCatalogCodes[0]
      state.searchCatalogCodes = Object.assign({}, state.searchCatalogCodes, code)
    },
    changeCatalogCodes: (state, action) => {
      let code = {}
      code[action.payload.key] = action.payload.itemData
      delete state.searchCatalogCodes[action.payload.key]
      state.searchCatalogCodes = Object.assign({}, state.searchCatalogCodes, code)
    },
    deleteCatalogCodes: (state, action) => {
      const obj = state.searchCatalogCodes
      delete obj[action.payload]
      state.searchCatalogCodes = obj
    },
    resetCatalogCode: (state, action) => {
      const obj = state.searchCatalogCodes
      obj[action.payload] = initialState.searchCatalogCodes['0']
      state.searchCatalogCodes = obj
    },
    resetCatalogCodes: (state) => {
      state.searchCatalogCodes = initialState.searchCatalogCodes
    }
  }
})

export const {
  hydrateSearchOption,
  setCategoryCode,
  setSortOrder,
  setSearchOptions,
  resetSearchOptions,
  setSearchType,
  setSearchPreset,
  setBloodTest,
  resetBloodTest,
  addCatalogCodes,
  changeCatalogCodes,
  deleteCatalogCodes,
  resetCatalogCode,
  resetCatalogCodes } = itemSearchOptionSlice.actions

export default itemSearchOptionSlice.reducer
